// extracted by mini-css-extract-plugin
export var main = "StageSwitcher-module--main--7IKve";
export var linkLineloop = "StageSwitcher-module--link-lineloop--3fhPX";
export var keyGnav = "StageSwitcher-module--key-gnav--WHl2v";